<template>
  <div class="inline-flex flex-col rounded-xl bg-darkGray p-1">
    <slot />
  </div>
</template>

<script setup></script>
